{
  "zh-CN": {
    "placeholders": {
      "name": "名称",
      "description": "描述",
      "amount": "金额",
      "login": "用户名或电子邮件",
      "username": "用户名",
      "twoFactorCode": "两步验证码",
      "confirmationCode": "确认码",
      "email": "电子邮件",
      "password": "密码",
      "passwordConfirmation": "确认密码",
      "homepage": "主页",
      "discord": "Discord 服务器",
      "youtube": "Youtube 频道",
      "twitch": "Twitch 频道",
      "distance": "距离",
      "color": "颜色",
      "title": "标题",
      "classification": "战斗、工业、多用途...",
      "focus": "轻型战斗机、采矿、货运...",
      "minSize": "舰载小艇、小型、中型...",
      "maxSize": "中型、大型、旗舰级...",
      "minCrew": "最少船员",
      "minCargo": "SCU",
      "modelId": "搜索飞船",
      "scenario": "Xenothreat、Pirate Swarm、赏金…",
      "briefing": "详细简报 — 通讯、呼号、交战规则…",
      "location": "Stanton、Pyro、ARC-L1…",
      "meetupLocation": "Daymar，太空港 — 4 号机库…",
      "maxAttendees": "可选上限",
      "autoLockMinutesBefore": "60",
      "timezone": "UTC",
      "startsAt": "选择开始日期和时间",
      "endsAt": "选择结束日期和时间（可选）",
      "notes": "携带额外弹药、可提供支援、10 分钟后到…",
      "signup-status": "已确认还是待定?",
      "features": {
        "username": "Username or User ID",
        "name": "功能名称"
      },
      "fleetInviteToken": "舰队邀请",
      "quicksearch": {
        "models": "Avenger, Carrack, Cutlass...",
        "hangar": "Enterprise, Andromeda..."
      },
      "search": {
        "default": "Search the Verse...",
        "roadmap-progress-tracker": "搜索"
      },
      "home": {
        "catalogueSearch": "舰船、物品、任务、地点..."
      },
      "image": {
        "caption": "标题"
      },
      "model": {
        "length": "长度",
        "beam": "宽度",
        "height": "高度",
        "price": "价格",
        "pledgePrice": "质押价格",
        "onSale": "在售",
        "mass": "质量",
        "crew": "船员",
        "storeUrl": "Store URL",
        "salesPageUrl": "Sales Page URL",
        "rsiId": "RSI ID",
        "scKey": "SC Key",
        "erkulIdentifier": "Erkul Identifier",
        "productionNote": "生产备注",
        "scmSpeed": "SCM Speed",
        "scmSpeedBoosted": "SCM Speed Boosted",
        "maxSpeed": "最大速度",
        "reverseSpeedBoosted": "Reverse Speed Boosted",
        "quantumFuelTankSize": "量子燃料箱大小",
        "hydrogenFuelTankSize": "氢燃料箱大小",
        "yaw": "Yaw",
        "pitch": "Pitch",
        "roll": "Roll",
        "yawBoosted": "偏航（增强）",
        "pitchBoosted": "俯仰（增强）",
        "rollBoosted": "翻滚（增强）",
        "fleetchartOffsetLength": "舰队图表长度偏移",
        "fleetchartOffsetBeam": "舰队图表宽度偏移",
        "extendedLength": "展开长度",
        "extendedBeam": "展开宽度",
        "extendedHeight": "展开高度",
        "extendedFleetchartOffsetLength": "展开舰队图偏移长度",
        "extendedFleetchartOffsetBeam": "展开舰队图偏移宽度",
        "landedLength": "着陆长度",
        "landedBeam": "着陆宽度",
        "landedHeight": "着陆高度",
        "landedFleetchartOffsetLength": "着陆舰队图长度偏移",
        "landedFleetchartOffsetBeam": "着陆舰队图宽度偏移",
        "cargo": "货物",
        "baseModel": "基础型号"
      },
      "cargoHold": {
        "offsetX": "偏移 X",
        "offsetY": "偏移 Y",
        "offsetZ": "偏移 Z",
        "rotation": "0 or 90",
        "maxLoadableContainerSizeScu": "货仓上限"
      },
      "manufacturer": {
        "longName": "全名",
        "code": "代码",
        "scRef": "SC Ref"
      },
      "announcement": {
        "title": "发生了什么？",
        "body": "支持 Markdown。会显示在收件箱和邮件中。",
        "discordPart": "一条消息",
        "socialPart": "一条帖子",
        "link": "/fleets/"
      },
      "fundingGoal": {
        "title": "服务器费用、域名、Discord...",
        "description": "可选说明，将公开显示",
        "amount": "100.00",
        "currency": "EUR",
        "effectiveFrom": "2026-01-01",
        "endedAt": "留空表示持续进行"
      },
      "gameEvent": {
        "title": "Invictus Launch Week",
        "description": "活动内容以及飞行员为何应该参加",
        "location": "New Babbage, microTech",
        "url": "https://robertsspaceindustries.com/..."
      },
      "supporterContribution": {
        "name": "公开显示的支持者名称",
        "amount": "5.00",
        "currency": "EUR",
        "startedAt": "2026-01-01",
        "endedAt": "2026-12-31",
        "payerEmail": "donor@example.com",
        "claimKey": "FY-7K2M-9QXD",
        "note": "可选的内部备注"
      },
      "component": {
        "componentType": "组件类型",
        "componentSubType": "组件子类型",
        "size": "尺寸",
        "grade": "等级",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "modelPaint": {
        "pledgePrice": "质押价格",
        "productionStatus": "生产状态",
        "productionNote": "生产备注"
      },
      "fleet": {
        "headquarters": "你们的舰队驻扎在哪里？",
        "fid": "舰队 ID",
        "rsiSid": "RSI SID",
        "ts": "Teamspeak 服务器",
        "description": "描述",
        "discord": {
          "guildId": "例如 123456789012345678",
          "channelId": "活动使用的语音频道 ID",
          "webhookUrl": "https://discord.com/api/webhooks/…",
          "webhookConfigured": "已保存 — 留空则保留现有值"
        },
        "homepage": "主页",
        "twitch": "Twitch 频道",
        "youtube": "Youtube 频道"
      },
      "adminUser": {
        "passwordConfirmation": "确认密码"
      },
      "user": {
        "rsiHandle": "RSI 用户名",
        "location": "e.g. Berlin, Germany",
        "currentSystem": "例如 Lorville、Port Tressler、Pyro"
      },
      "oauthApplication": {
        "name": "我的应用",
        "redirectUri": "https://example.com/callback",
        "scopes": "公开"
      },
      "vehicle": {
        "serial": "Serial"
      },
      "itemPrice": {
        "price": "0.00",
        "location": "位置",
        "locationUrl": "位置 URL"
      },
      "video": {
        "url": "YouTube Video ID"
      },
      "modelModule": {
        "name": "模块名称",
        "price": "0.00",
        "pledgePrice": "0.00",
        "productionStatus": "已公布, 可飞行, 概念中...",
        "scKey": "SC Key",
        "search": "按名称搜索模块..."
      },
      "modelUpgrade": {
        "name": "升级名称",
        "pledgePrice": "0.00",
        "description": "描述"
      },
      "modelModulePackage": {
        "name": "套餐名称",
        "pledgePrice": "0.00",
        "description": "描述"
      },
      "dock": {
        "name": "停靠口名称",
        "length": "长度（米）",
        "beam": "宽度（米）",
        "height": "高度（米）"
      },
      "modelPosition": {
        "name": "岗位名称",
        "position": "0"
      },
      "logistics": {
        "inventoryName": "Main Depot, Cargo Bay...",
        "description": "Optional details about this inventory",
        "location": "e.g. Port Olisar, Area18",
        "itemName": "Titanium, Medical Supplies..."
      },
      "filters": {
        "vehicles": {
          "name": "Enterprise, Andromeda...",
          "priceLt": "价格 <=",
          "priceGt": "价格 >="
        },
        "models": {
          "name": "Gladius, Andromeda...",
          "classification": "载具、战斗机、货船...",
          "manufacturer": "Origin, Robert Space Industries, Aegis...",
          "onSale": "是或否",
          "productionStatus": "已公布、可飞行、概念阶段..."
        },
        "modelModules": {
          "name": "Bio Dome, Cargo Module..."
        },
        "manufacturers": {
          "name": "Origin, Robert Space Industries, Aegis..."
        },
        "supporterContributions": {
          "name": "Alice、Bob...",
          "startedAtGteq": "2026-01-01",
          "startedAtLteq": "2026-12-31"
        },
        "adminNotifications": {
          "search": "标题或内容..."
        },
        "users": {
          "search": "用户名或电子邮件",
          "username": "用户名",
          "rsiHandle": "RSI 用户名",
          "email": "电子邮件"
        },
        "components": {
          "name": "名称",
          "description": "量子驱动器、装甲板……",
          "manufacturer": "Behring、Ascension Astro、Juno Starwerk……"
        },
        "fleets": {
          "name": "名称",
          "fid": "FID",
          "memberCountGteq": "最少成员数",
          "memberCountLteq": "最多成员数",
          "createdOnGteq": "2026-01-01",
          "createdOnLteq": "2026-12-31",
          "members": {
            "search": "用户名或昵称"
          }
        },
        "destroyedFleets": {
          "nameOrFid": "名称或 FID"
        },
        "commodities": {
          "name": "Agricium、Laranite、Quantainium…",
          "description": "ore、ammunition、material……",
          "uexCode": "UEX Code"
        },
        "equipment": {
          "name": "Arclight, Pembroke, Novikov..."
        },
        "notifications": {
          "search": "标题或内容..."
        },
        "blueprints": {
          "name": "Greatsword、Testudo、Omnisky…",
          "material": "铁、钛、Aphorite…",
          "craftableType": "部件、装备…",
          "source": "已知、未知…"
        },
        "fleetDirectory": {
          "search": "名称、FID 或 SID...",
          "memberCountGteq": "最少成员数"
        }
      },
      "commodity": {
        "commodityType": "Commodity Type",
        "uexId": "UEX ID",
        "uexCode": "UEX Code",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "equipment": {
        "equipmentType": "Equipment Type",
        "itemType": "Item Type",
        "subType": "Sub Type",
        "weaponClass": "Weapon Class",
        "size": "Size",
        "grade": "Grade",
        "scKey": "SC Key",
        "scRef": "SC Ref"
      },
      "relationships": {
        "user": {
          "handle": "对方的用户名"
        },
        "fleet": {
          "handle": "对方的舰队标识"
        }
      },
      "reward": "报酬（aUEC）",
      "crewLimit": "不限",
      "deadline": "无截止时间",
      "itemName": "需要交付的物品",
      "itemQuantity": "数量",
      "itemQuality": "600"
    }
  }
}
